export default class ErrorLogService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('error_logs', params)
	}

	getEntity(id, params) {
		return this.apiService.callGet('error_logs/' + id, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/ErrorLogService.js